import { Box, Hint, tokens } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

export const ScheduleOnboardingHint = () => {
  const [scheduleOnboardingHintIsHidden, setScheduleOnboardingHintIsHidden] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideScheduleOnboardingHint)

  useEffect(() => {
    track(trackingEvents.projectManagement.hints.viewScheduleOnboardingHint)
  }, [])

  const handleHintClose = () => {
    track(trackingEvents.projectManagement.hints.closeScheduleOnboardingHint)
    setScheduleOnboardingHintIsHidden(true)
  }

  return (
    <Hint.Popover.Provider
      steps={3}
      isHidden={!!scheduleOnboardingHintIsHidden}
      onClose={handleHintClose}
      onFinish={handleHintClose}
    >
      <Box position="absolute" style={{ top: '0%', left: '7%', zIndex: tokens.zIndex.popovers }}>
        <Hint.Popover
          step={1}
          actionLabel={i18n.t('trial_employees.hint.first_step.cta_label')}
          title={i18n.t('project_management.hints.schedule.step_one.title')}
          description={i18n.t('project_management.hints.schedule.step_one.description')}
          position="bottom right"
        />
      </Box>
      <Box position="absolute" style={{ top: '35%', left: '14%', zIndex: tokens.zIndex.popovers }}>
        <Hint.Popover
          step={2}
          actionLabel={i18n.t('trial_employees.hint.first_step.cta_label')}
          title={i18n.t('project_management.hints.schedule.step_two.title')}
          description={i18n.t('project_management.hints.schedule.step_two.description')}
          position="right top"
        />
      </Box>
      <Box position="absolute" style={{ top: '15%', left: '1%', zIndex: tokens.zIndex.popovers }}>
        <Hint.Popover
          step={3}
          actionLabel={i18n.t('trial_employees.hint.second_step.cta_label')}
          title={i18n.t('project_management.hints.schedule.step_three.title')}
          description={i18n.t('project_management.hints.schedule.step_three.description')}
          position="bottom right"
        />
      </Box>
    </Hint.Popover.Provider>
  )
}
